import React from "react";
// import axios from "axios";

function PaperInfo({
  formData,
  setFormData,
  wordLimit,
  setWordLimit,
  setIsValid,
  isValid,
  researchAreas,
  setResearchAreas,
}) {
  // Commented out API call - research areas now come from static data in Form.js
  // useEffect(() => {
  //   const fetchResearchAreas = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/submit/get-research-areas`
  //       );
  //       setResearchAreas(response.data.researchAreas);
  //     } catch (error) {
  //       console.error("Error fetching research areas:", error);
  //     }
  //   };

  //   fetchResearchAreas();
  // }, [setResearchAreas]);

  return (
    <div className="paper-submission-container">
      <div className="paper-info-wrapper">
        <div className="paper-field-group">
          <label className="paper-field-label">
            <span className="paper-label-text">Title</span>
            <span className="paper-required-mark">*</span>
          </label>
          <input
            className="paper-input-field"
            type="text"
            placeholder="Enter your paper title..."
            value={formData.title}
            required
            onChange={(event) =>
              setFormData({ ...formData, title: event.target.value })
            }
          />
        </div>

        <div className="paper-field-group">
          <label className="paper-field-label">
            <span className="paper-label-text">Abstract</span>
            <span className="paper-required-mark">*</span>
          </label>
          <textarea
            className="paper-textarea-field"
            id="paper-abstract-input"
            placeholder="Enter your paper abstract..."
            value={formData.abstract}
            onChange={(e) => {
              let inputText = e.target.value;
              let words = inputText
                .replace(/[\t\n\r\.\?\!]/gm, " ")
                .split(" ")
                .map((word) => word.trim())
                .filter((word) => word.length > 0);

              if (words.length > 350) {
                setIsValid(false);
                document.querySelector("#paper-textarea-message").innerText =
                  "Maximum 350 words allowed!";
                document
                  .getElementById("paper-abstract-input")
                  .classList.add("paper-input-error");
                return; 
              }

              setIsValid(true);
              setFormData({ ...formData, abstract: inputText });
              setWordLimit(words.length);
              document
                .getElementById("paper-abstract-input")
                .classList.remove("paper-input-error");
              document.querySelector("#paper-textarea-message").innerText = "";
            }}
          />

          <div className="paper-word-count-container">
            <span
              className={`paper-word-count ${
                isValid ? "paper-word-count-valid" : "paper-word-count-invalid"
              }`}
            >
              {wordLimit}/350 words
            </span>
            <span
              id="paper-textarea-message"
              className="paper-error-message"
            ></span>
          </div>
        </div>

        <div className="paper-field-group">
          <label className="paper-field-label">
            <span className="paper-label-text">Keywords</span>
            <span className="paper-field-hint">
              (Maximum 5 keywords, separated by comma)
            </span>
            <span className="paper-required-mark">*</span>
          </label>
          <input
            className="paper-input-field"
            type="text"
            placeholder="Enter keywords separated by comma..."
            value={formData.keywords}
            onChange={(event) => {
              const inputKeywords = event.target.value;
              const keywordArray = inputKeywords
                .split(",")
                .map((keyword) => keyword.trim())
                .filter((keyword) => keyword !== "");

              if (keywordArray.length > 5) {
                setIsValid(false);
                document.getElementById("paper-keywords-message").innerText =
                  "Maximum 5 keywords allowed";
                document
                  .getElementById("paper-keyword-input")
                  .classList.add("paper-input-error");
              } else {
                setIsValid(true);
                document.getElementById("paper-keywords-message").innerText =
                  "";
                document
                  .getElementById("paper-keyword-input")
                  .classList.remove("paper-input-error");
                setFormData({ ...formData, keywords: inputKeywords });
              }
            }}
            id="paper-keyword-input"
          />
          <span
            id="paper-keywords-message"
            className="paper-error-message"
          ></span>
        </div>

        <div className="paper-field-group">
          <label className="paper-field-label">
            <span className="paper-label-text">Presentation Type</span>
            <span className="paper-required-mark">*</span>
          </label>
          <select
            name="presentationType"
            value={formData.presentationType}
            onChange={(event) =>
              setFormData({ ...formData, presentationType: event.target.value })
            }
            className="paper-select-field"
          >
            <option value="">Select presentation type</option>
            <option value="Oral">Oral Presentation</option>
            <option value="Poster">Poster Presentation</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default PaperInfo;
